import {EtsyList, EtsyListing, EtsyParamIncludesEnum} from '@coolcolduk/etsy';
import {useEffect, useState} from 'react';
import getAxios from '../util/axios/getAxios';
import withFirebaseToken from '../util/firebase/withFirebaseToken';

/**
 * Fetch listing using the Axios client.
 * @param token - token for our api
 * @param accessToken - etsy access token
 * @param shopId - shop to fetch data from
 * @param listingId
 * @returns The listing response.
 */
export const fetchListing = async (
  token: string,
  shopRecordId: string,
  listingId: string,
  includes?: EtsyParamIncludesEnum[],
): Promise<EtsyListing> => {
  const response = await getAxios('etsy', {token}).get<EtsyList<EtsyListing>>(`getListing`, {
    params: {
      listingId,
      shopRecordId,
      includes,
    },
  });

  return response.data;
};

export const useGetListing = (shopRecordId?: string, listingId?: string, includes?: EtsyParamIncludesEnum[]) => {
  const [data, setData] = useState<EtsyListing | undefined>(undefined);

  useEffect(() => {
    withFirebaseToken(async (token) => {
      if (!token || !shopRecordId || !listingId) {
        setData(undefined);
        return;
      }
      setData(await fetchListing(token, shopRecordId, listingId, includes));
    });
  }, [listingId, shopRecordId, setData, includes]);

  return data;
};
